/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Household(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.76968 2.61901C9.94445 2.56262 10.1353 2.57205 10.3048 2.64733L17.8048 5.98132C18.0753 6.10164 18.2498 6.36989 18.2502 6.66589V17.4999C18.25 17.9139 17.9143 18.2499 17.5002 18.2499C17.086 18.2499 16.7503 17.9139 16.7502 17.4999V7.15319L10.0002 4.15319L3.25015 7.15319V17.4999C3.24998 17.9139 2.91426 18.2499 2.50015 18.2499C2.08605 18.2499 1.75033 17.9139 1.75015 17.4999V6.66589C1.75045 6.36989 1.92499 6.10164 2.19546 5.98132L9.69546 2.64733L9.76968 2.61901ZM10.0002 8.41589C10.4198 8.41589 10.8224 8.58317 11.1193 8.87976C11.4161 9.17658 11.583 9.58011 11.5832 9.99987V10.0829H14.1671C14.5811 10.0831 14.9169 10.419 14.9171 10.8329V17.4999C14.917 17.9138 14.5811 18.2497 14.1671 18.2499H5.83316C5.4192 18.2497 5.08333 17.9138 5.08316 17.4999V12.4999C5.0834 12.086 5.41924 11.75 5.83316 11.7499H6.75015V9.99987C6.75027 9.58011 6.91719 9.17658 7.21402 8.87976C7.51084 8.58314 7.91353 8.41598 8.33316 8.41589H10.0002ZM6.58316 16.7499H10.0832V13.2499H6.58316V16.7499ZM11.5832 16.7499H13.4171V11.5829H11.5832V16.7499ZM8.33316 9.91589C8.31136 9.91597 8.29008 9.92499 8.27457 9.9403C8.25904 9.95583 8.25027 9.97792 8.25015 9.99987V11.7499H10.0832V9.99987C10.083 9.97792 10.0743 9.95583 10.0587 9.9403C10.0432 9.92501 10.022 9.91589 10.0002 9.91589H8.33316Z"
        fill="#35424F"
      />
    </svg>
  )
}

Household.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Household
